namespace advisorop.components.meetinghub {
    export class StartTimeEndTimeController {
        schedule: domains.IMeetingAvailabilityScheduleInline;
        dbStartTime: DevExpress.ui.dxDateBoxOptions;
        dbEndTime: DevExpress.ui.dxDateBoxOptions;

        constructor(private meetingHubService: services.MeetingHubService) {
            this.dbStartTime = {
                bindingOptions: {
                    value: "vm.schedule.startTime",
                    max: "vm.schedule.endTime"
                },
                type: "time",
                pickerType: "native",
                onChange: (e) => {
                    this.onChange(e, this.schedule.endTime);
                }
            }
            this.dbEndTime = {
                bindingOptions: {
                    value: "vm.schedule.endTime",
                    min: "vm.schedule.startTime"
                },
                type: "time",
                pickerType: "native",
                onChange: (e) => {
                    this.onChange(e, this.schedule.startTime);
                }
            }
        }

        onChange(e: any, dateLimit: Date): void {
            if (e.component.option("isValid")) {
                return;
            }
            e.component.option("value", dateLimit)
        }

        $onInit(): void {
        }

        $onChanges(evt) {
            console.log(evt);
        }
    }

    class StartTimeEndTime implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                schedule: '=',
            };
            this.controller = [`meetingHubService`, StartTimeEndTimeController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/start-time-end-time.html`;
        }
    }
    angular.module(Constants.APP).component(`startTimeEndTime`, new StartTimeEndTime());
}